/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signupfailed2Inputs */

const zh_auth_signupfailed2 = /** @type {(inputs: Auth_Signupfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册失败`)
};

const en_auth_signupfailed2 = /** @type {(inputs: Auth_Signupfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up failed`)
};

const es_auth_signupfailed2 = /** @type {(inputs: Auth_Signupfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al registrarse`)
};

/**
* | output |
* | --- |
* | "Sign up failed" |
*
* @param {Auth_Signupfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_signupfailed2 = /** @type {((inputs?: Auth_Signupfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signupfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_signupfailed2(inputs)
	if (locale === "en") return en_auth_signupfailed2(inputs)
	return es_auth_signupfailed2(inputs)
});
export { auth_signupfailed2 as "auth_signUpFailed" }